import { Injectable } from '@angular/core';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { AppSnackBarService } from './app-snack-bar.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private readonly snackBar: AppSnackBarService) {}

  default(message: string) {
    this.show(message, { duration: 2000, panelClass: 'default-notification-overlay' });
  }

  info(message: string) {
    this.show(message, { duration: 2000, panelClass: 'info-notification-overlay' });
  }

  success(message: string) {
    this.show(message, { duration: 2000, panelClass: 'success-notification-overlay' });
  }

  warn(message: string) {
    this.show(message, { duration: 2500, panelClass: 'warning-notification-overlay' });
  }

  error(message: string) {
    // No duration -> sticky. The proxy keeps it sticky under every preset and wires click-to-dismiss.
    this.show(message, { panelClass: 'error-notification-overlay' });
  }

  dismiss() {
    this.snackBar.dismiss();
  }

  private show(message: string, configuration: MatSnackBarConfig) {
    // Zone handling + click-to-dismiss now live in AppSnackBarService.
    this.snackBar.open(message, undefined, configuration);
  }
}
